import axios from 'axios';

const updateBlocklistSettings = (setting = {}) => {
  return axios.put('block-list', setting);
};

export { updateBlocklistSettings };
